import SettingsTypes from './SettingsTypes';

export const getTmsSettingsInProgress = (payload) => ({
  type: SettingsTypes.GET_TMS_SETTINGS_PROGRESS,
  payload,
});

export const getTmsSettingsInSuccess = (payload) => ({
  type: SettingsTypes.GET_TMS_SETTINGS_SUCCESS,
  payload,
});

export const getTmsSettingsInError = (payload) => ({
  type: SettingsTypes.GET_TMS_SETTINGS_ERROR,
  payload,
});

export const saveTmsSettingsInProgress = (payload) => ({
  type: SettingsTypes.SAVE_TMS_SETTINGS_PROGRESS,
  payload,
});

export const saveTmsSettingsInSuccess = (payload) => ({
  type: SettingsTypes.SAVE_TMS_SETTINGS_SUCCESS,
  payload,
});

export const saveTmsSettingsInError = (payload) => ({
  type: SettingsTypes.SAVE_TMS_SETTINGS_ERROR,
  payload,
});

export const getUserThemesInProgress = (payload) => ({
  type: SettingsTypes.GET_USER_THEMES_PROGRESS,
  payload,
});
export const getUserThemesInSuccess = (payload) => ({
  type: SettingsTypes.GET_USER_THEMES_SUCCESS,
  payload,
});
export const getUserThemesInError = (payload) => ({
  type: SettingsTypes.GET_USER_THEMES_ERROR,
  payload,
});
export const setUserThemes = (payload) => ({
  type: SettingsTypes.SET_USER_THEMES,
  payload,
});

export const deleteTmsSettingsShipmentRestriction = (payload) => ({
  type: SettingsTypes.DELETE_TMS_SETTINGS_SHIPMENT_RESTRICTION,
  payload,
});
